import { scanCommentOrString } from './CsCommentStringScanner';

/**
 * Strips C# attribute blocks (`[Foo]`, `[FromBody]`, `[Attr(1,2)]`) from source,
 * WITHOUT touching array-type brackets (`int[]`, `List<int>[]`). Distinguishes
 * them by what precedes the `[`: an attribute is preceded by whitespace/
 * newline/opening-punctuation (start of a statement/parameter), an array
 * bracket is directly attached to an identifier/`]`/`>` (part of a type).
 * Bracket-depth aware (handles `[Attr(new[] {1,2})]`).
 * Comments and string/char literals are copied verbatim first (via the shared
 * CsCommentStringScanner) — a `[` inside a `///` doc-comment or a string is
 * never mistaken for an attribute, since this ran blind to comments/strings
 * before (see Development.Patterns — sanitizer/comment example).
 * @param {string} source
 * @returns {string}
 */
export function stripAttributes(source) {
  let result = '';
  let i = 0;
  while (i < source.length) {
    const span = scanCommentOrString(source, i);
    if (span) {
      result += source.slice(i, span.end);
      i = span.end;
      continue;
    }

    const ch = source[i];
    if (ch === '[' && !isArrayBracket(result)) {
      let depth = 0;
      let j = i;
      for (; j < source.length; j += 1) {
        if (source[j] === '[') depth += 1;
        if (source[j] === ']') {
          depth -= 1;
          if (depth === 0) {
            j += 1;
            break;
          }
        }
      }
      i = j;
      continue;
    }
    result += ch;
    i += 1;
  }
  return result;
}

function isArrayBracket(resultSoFar) {
  for (let k = resultSoFar.length - 1; k >= 0; k -= 1) {
    const ch = resultSoFar[k];
    if (/\s/.test(ch)) continue;
    return /[A-Za-z0-9_\]>]/.test(ch);
  }
  return false;
}
